let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

// Loud, attention-grabbing multi-beep alert chime for PC
export function playAlert() {
  try {
    const audio = getCtx();
    const now = audio.currentTime;
    const notes = [880, 1175, 880, 1175, 1568];
    notes.forEach((freq, i) => {
      const t = now + i * 0.22;
      const osc = audio.createOscillator();
      const gain = audio.createGain();
      osc.type = "square";
      osc.frequency.setValueAtTime(freq, t);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.35, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.2);
      osc.connect(gain);
      gain.connect(audio.destination);
      osc.start(t);
      osc.stop(t + 0.2);
    });
  } catch (e) {
    console.error("playAlert error", e);
  }
}

// Short soft "ding" for a new chat reply
export function playDing() {
  try {
    const audio = getCtx();
    const now = audio.currentTime;
    [1318, 1760].forEach((freq, i) => {
      const t = now + i * 0.12;
      const osc = audio.createOscillator();
      const gain = audio.createGain();
      osc.type = "sine";
      osc.frequency.setValueAtTime(freq, t);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.5, t + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.6);
      osc.connect(gain);
      gain.connect(audio.destination);
      osc.start(t);
      osc.stop(t + 0.6);
    });
  } catch (e) {
    console.error("playDing error", e);
  }
}

// Ensure AudioContext is unlocked on a user gesture
export function unlockAudio() {
  getCtx();
}
